module.exports = __webpack_public_path__ + "static/media/sliderItem3.91baec6e.JPG";